export const getClassTypeNotification = notiType =>{
    let obj = {
        Creation: 'colorVerde',
        Cancel: 'colorRojo',
        Document: 'colorNaranja',
        Update: 'colorAzul',
        Prescription: 'colorBlack',
        SMS: 'colorGray',
        DoctorNotConnected: 'colorRojo',
        Reassigned: 'colorAzul'
    }
    return obj[notiType];
}